const config = {
  siteTitle: 'Wei',
  siteTitleShort: 'Wei',
  siteTitleAlt: "Wei's home in the open web",
  siteLogo: '/logos/uu.png',
  siteUrl: 'https://wgao19.cc/',
  pathPrefix: '/',
  siteDescription: "Wei's home in the open web",
  // siteRss: "/rss.xml", // Path to the RSS file.
  siteFBAppID: '',
  googleAnalyticsID: 'UA-133341999-3',
  postDefaultCategoryID: 'Personal site',
  dateFromFormat: 'MMM-DD-YYYY',
  dateFormat: 'MM/DD/YYYY',
  userName: 'Wei Gao',
  userEmail: 'wgao19@gmail.com',
  userTwitter: 'wgao19',
  userLocation: 'Singapore',
  userAvatar: 'https://i.imgur.com/uS7WXSw.jpg',
  userDescription: "Wei's home in the open web",
  userLinks: [
    {
      label: 'GitHub',
      url: 'https://github.com/wgao19/',
      iconClassName: 'fa fa-github',
    },
    {
      label: 'Twitter',
      url: 'https://twitter.com/wgao19',
      iconClassName: 'fa fa-twitter',
    },
  ],
  copyright: 'Copyright © 2019. Wei Gao',
  themeColor: '#000', // Used for setting manifest and progress theme colors.
  backgroundColor: '#e0e0e0', // Used for setting manifest background color.
};

// Validate

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === '/') {
  config.pathPrefix = '';
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, '')}`;
}

// Make sure siteUrl doesn't have an ending forward slash
if (config.siteUrl.substr(-1) === '/')
  config.siteUrl = config.siteUrl.slice(0, -1);

// Make sure siteRss has a starting forward slash
if (config.siteRss && config.siteRss[0] !== '/')
  config.siteRss = `/${config.siteRss}`;

module.exports = config;
